/**
 * Uploaded files (photos, documents) are saved as absolute URLs built from the
 * request host at upload time. Rows created against a dev box or the bare
 * server IP (http://localhost:3000/..., http://16.192.35.186/...) would render
 * broken, so those keep only the /uploads/... path and resolve against
 * whatever host serves the console. Real domain URLs are kept as-is — the file
 * lives there.
 */
export const uploadSrc = (url: string): string => {
  if (!url) return '';
  const local = /^https?:\/\/(localhost|127\.0\.0\.1|\d{1,3}(\.\d{1,3}){3})(:\d+)?\//i.test(url);
  if (/^https?:\/\//i.test(url) && !local) return url;
  const match = /\/uploads\/.*$/.exec(url);
  return match ? match[0] : url;
};

/** True when the URL points at a browser-renderable image (by extension). */
export const isImageUrl = (url: string): boolean =>
  /\.(jpe?g|png|gif|webp|bmp|svg|avif)(\?|#|$)/i.test(url);
